var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#F2F0F0",
  rx: 12
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#666",
  d: "m15.254 12.297 3.062 1.312c.493.192.766.711.657 1.23l-.657 3.063c-.109.492-.574.875-1.066.875-.191 0-.355-.027-.52-.027-.273 0-.546-.027-.793-.055A12.248 12.248 0 0 1 5 6.5c0-.492.355-.957.848-1.066l3.062-.657c.52-.109 1.04.164 1.23.657l1.313 3.062c.192.438.082.957-.3 1.258l-1.122.93a8.497 8.497 0 0 0 3.035 3.035l.93-1.121c.3-.383.82-.493 1.258-.301Zm1.805 5.14.574-2.707-2.735-1.175-.793.984a1.338 1.338 0 0 1-1.695.3 9.757 9.757 0 0 1-3.5-3.5 1.338 1.338 0 0 1 .3-1.694l.985-.793L9.02 6.117l-2.707.574a10.891 10.891 0 0 0 10.746 10.746Z"
})));
export default SvgPhone;